import(/* webpackMode: "eager" */ "/codebuild/output/src3905947239/src/apps/fanychance/src/app/error.tsx");
